<template>
  <v-container class="container p-10">
    <v-text-field prepend-icon="mdi-pencil" class="m4" variant="underlined" v-model="name" clearable label="Name"></v-text-field>
   
    <ShiftSelector @schicht-selected="(shift) => {selectedShift = shift}"></ShiftSelector>
   
    <v-calendar
        transparent
        expanded
        borderless
        mode="dateTime"
        :min-date=startDate
        :max-date=endDate
        :attributes="attributes"
        show-iso-weeknumbers="left"
        @dayclick="dayClick"
    >
    </v-calendar>
    <v-row class="d-flex justify-center mt-4 mb-4">
      <v-btn color="secondary" @click="onCancel" class="mb-2">Zurück</v-btn>
      <v-btn color="primary" @click="onSave" class="ml-2">Speichern</v-btn>
    </v-row>
  </v-container>
</template>

<script>
import {onMounted, ref, watch} from "vue";
import { v4 as uuidv4 } from 'uuid';
import ShiftSelector from "@/components/ShiftSelector.vue";
import {checkRuleBreaksForShifts} from "@/rules/ruleEngine";
import {notifyWarning} from "vuetify3-dialog";
import {GetTemplateData, InsertTemplateData} from "@/data/templateData.ts";
import {useStore} from "@/store/index";
export default {
  components: {
    ShiftSelector
  },
  props: {
    template: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const store = useStore();
    const id = ref(props.template ? props.template.id : uuidv4());
    const name = ref(props.template ? props.template : '');
    const userId = ref(store.getters.userId);
    const emplno = ref(store.getters.emplno);
    const inputDates = ref([]);
    const selectedShift = ref('');
    const attributes = ref([
      {
        key: '1', //Früh
        highlight: {
          color: 'orange',
          fillMode: 'solid',
          contentClass: 'italic',
        },
        dates:  [],
      },
      {
        key: '2',  //Mittel
        highlight: {
          color: 'pink',
          fillMode: 'solid',
          contentClass: 'italic',
        },
        dates: [],
      },
      {
        key: '3', //Spät
        highlight: {
          color: 'purple',
          fillMode: 'solid',
          contentClass: 'italic',
        },
        dates: [],
      },
      {
        key: '5', //Geteilt
        highlight: {
          color: 'teal',
          fillMode: 'solid',
          contentClass: 'italic',
        },
        dates: [],
      },
      {
        key: '4', //NE
        highlight: {
          color: 'blue',
          fillMode: 'solid',
          contentClass: 'italic',
        },
        dates: [],
      },
      {
        key: '10', //Frei
        highlight: {
          color: 'green',
          fillMode: 'solid',
          contentClass: 'italic',
        },
        dates: [],
      }
    ]);

    const startDate = ref(new Date('2024-01-01').setHours(0, 0, 0, 0));
    const endDate = ref(new Date('2024-02-25').setHours(0, 0, 0, 0));
    const ruleBreaks = ref([]);
    
    onMounted(async () => {
      try{
        const templateData = await GetTemplateData(id.value);
        
        name.value = templateData.name;

        templateData.dates.forEach((date) => {
          inputDates.value.push(date);
        });
      }
      catch(e)
      {
        console.error('Didnt find document:', e);
      }
    });
    
    watch(inputDates.value, (newVal) => {
      attributes.value.forEach(attribute => {
          attribute.dates = [];
      });
      
      newVal.forEach(dateObject => {
        const attribute = attributes.value.find(attr => attr.key == dateObject.shift);
        if (attribute) {
          attribute.dates.push(dateObject.date);
        }
      });

      const rulebreaks = checkRuleBreaksForShifts(newVal);
      
      ruleBreaks.value.splice(0, ruleBreaks.value.length);
      
      rulebreaks.forEach((rule) => {
        ruleBreaks.value.push(rule);
        notifyWarning(rule, {timeout: 10000, timer: true, closeOnContentClick: true}).then(() => {})
      });
    });

    function addDate(date, shift) {
      const index = inputDates.value.findIndex(d => d.date.getTime() === date.getTime());
      const oldValue = inputDates.value[index];
      if(index !== -1) {
        inputDates.value.splice(index, 1);
        if(oldValue.shift !== shift && date >= startDate.value && date <= endDate.value) {
          inputDates.value.push({id: uuidv4(), date: date, shift: shift});
        }
      }
      else if(date >= startDate.value && date <= endDate.value){
        inputDates.value.push({id: uuidv4(), date: date, shift: shift});
      }
    }
    
    const dayClick = (day) => {
      switch (selectedShift.value) {
        case 'frueh':
          addDate(day.date, 1);
          break;
        case 'spaet':
          addDate(day.date, 3);
          break;
        case 'mittel':
          addDate(day.date, 2);
          break;
        case 'geteilt':
          addDate(day.date, 5);
          break;
        case 'ne':
          addDate(day.date, 4);
          break;
        case 'frei':
          addDate(day.date, 10);
          break;
      }
    };

    return { id,name,userId, attributes, selectedShift, dayClick, startDate, endDate, inputDates, ruleBreaks};
  },
  methods: {
    onSave() {
      if(this.ruleBreaks.length > 0) {
        notifyWarning('Es gibt Regelverstöße. Bitte korrigieren Sie diese.', {timeout: 10000, timer: true, closeOnContentClick: true}).then(() => {})
        return;
      }
      
      if(this.inputDates.length !== 56) {
        notifyWarning('Sie müssen die Vorlage komplett ausfüllen.', {timeout: 10000, timer: true, closeOnContentClick: true}).then(() => {})
        return;
      }
      
      if(this.name === '' || this.name === null || this.name === undefined)
      {
        notifyWarning('Bitte geben Sie einen Namen für die Vorlage ein.', {timeout: 10000, timer: true, closeOnContentClick: true}).then(() => {})
        return;
      }
      
      this.$emit('template-save',
          { id: this.id,
            name: this.name,
            userId: this.userId,
            emplno: this.emplno,
            inputDates: this.inputDates});
      
    },
    onCancel() {
      this.$emit('template-back', false);
    },
  },
};
</script>

<style scoped>
.container {
  border-radius: 5px;
  background: white;
}
</style>